import { render, staticRenderFns } from "./SerialScreen.vue?vue&type=template&id=7f4ccd61&scoped=true&"
import script from "./SerialScreen.vue?vue&type=script&lang=js&"
export * from "./SerialScreen.vue?vue&type=script&lang=js&"
import style0 from "./SerialScreen.vue?vue&type=style&index=0&id=7f4ccd61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4ccd61",
  null
  
)

export default component.exports